import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { navigation } from '../data/site';
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  return <header className="sticky top-0 z-40 border-b border-line/70 bg-paper/95 backdrop-blur" data-id="element-117" data-mp="1inbg5ko5wwgs">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6 lg:px-10" data-id="element-118" data-mp="uxzbmy3s5ckt">
        <Link to="/" className="font-display text-2xl font-medium tracking-tight text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-wood" data-id="element-119" data-mp="qwx7c2v0aabz">
          Elisabete Costa
        </Link>

        <nav aria-label="Navigation principale" className="hidden items-center gap-8 lg:flex" data-id="element-120" data-mp="zwkaat3dvo75">
          {navigation.map(item => <NavLink key={item.to} to={item.to} className="whitespace-nowrap text-sm text-ink-soft transition-colors duration-150 hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-wood" data-id="element-121" data-mp="2gdof73niqdm4">
              {item.label}
            </NavLink>)}
          <Link to="/contact" className="whitespace-nowrap rounded-full bg-ink px-5 py-2.5 text-sm font-medium text-paper transition-colors duration-150 hover:bg-wood-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-wood focus-visible:ring-offset-2 focus-visible:ring-offset-paper" data-id="element-122" data-mp="2jhgirt4t36c7">
            Contact
          </Link>
        </nav>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'} className="rounded-full p-2 text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-wood lg:hidden" data-id="element-123" data-mp="20rryctykz8b3">
          {open ? <XIcon className="h-6 w-6" data-id="element-124" data-mp="1cztalahy3kh2" /> : <MenuIcon className="h-6 w-6" data-id="element-125" data-mp="150ycwjojqsrd" />}
        </button>
      </div>

      <AnimatePresence data-id="element-126" data-mp="14yvfvfoz7zd5">
        {open && <motion.nav id="mobile-nav" aria-label="Navigation mobile" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-line bg-paper px-6 pb-8 pt-4 lg:hidden" data-id="element-127" data-mp="102wu7zv18vgf">
            <ul className="flex flex-col" data-id="element-128" data-mp="h3sqn6m9ftw5">
              {[...navigation, {
            label: 'Contact',
            to: '/contact'
          }].map(item => <li key={item.to} className="border-b border-line/70" data-id="element-129" data-mp="w1bdu4jahz1h">
                  <Link to={item.to} onClick={() => setOpen(false)} className="block py-4 font-display text-2xl text-ink" data-id="element-130" data-mp="r0xedavr7xf2">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}